"use client";

import { CalendarDays, Ticket } from "lucide-react";
import { Eventi } from "@/types/globals";
import NewEventCard from "./NewEventCard";
import { useState } from "react";
declare type ResultApiRecenTrips = {
  availableEvents: Eventi[];
};
type EventDescription = {
  title: string;
  subtitle: string;
};
const EVENT_DESCRIPTION: {
  [id: string]: EventDescription;
} = {
  MUSEUMS: {
    title: "Musées guidés",
    subtitle: "Découvrez les musées de Paris et ses environs"
  },
  FOOD_TASTING: {
    title: "Dégustation de vins/champagnes",
    subtitle: "Découvrez les meilleurs restaurants de Paris et ses environs"
  },
  ATTRACTIONS: {
    title: "Attractions",
    subtitle: "Découvrez les attractions de Paris et ses environs"
  },
  TICKETS: {
    title: "Billets",
    subtitle: "Découvrez les meilleurs billets de Paris et ses environs"
  },
  TOURS: {
    title: "Balades guidées",
    subtitle: "Découvrez les meilleurs tours de Paris et ses environs"
  },
  MONUMENTS: {
    title: "Monuments",
    subtitle: "Découvrez les monuments de Paris et ses environs"
  },
  CRUISE: {
    title: "Croisières",
    subtitle: "Découvrez les croisières de Paris et ses environs"
  },
  SHOWS: {
    title: "Spectacles",
    subtitle: "Découvrez les spectacles de Paris et ses environs"
  },
  "SEGWAY/E-BIKE": {
    title: "Segway / E-Bike",
    subtitle: "Découvrez les spectacles de Paris et ses environs"
  },
  FOOD_TOURING: {
    title: "Balades et dégustations",
    subtitle: "Découvrez les meilleurs balades gustatives"
  },
  COOKING_CLASS: {
    title: "Cours de cuisine",
    subtitle: "Découvrez les meilleurs cours de cuisine"
  },
  TEST: {
    title: "Tests",
    subtitle: ""
  },
  WIP: {
    title: "En cours",
    subtitle: ""
  }
};
const SelectionEventList = ({
  eventList,
  title,
  category,
  subtitle,
  displayCategories,
  setDisplayCategories,
  maxNumber,
  displayTotal
}: {
  eventList: Eventi[];
  title: string;
  category: string;
  subtitle: string;
  displayCategories: string[];
  setDisplayCategories?: (categories: string[]) => void;
  maxNumber: number;
  displayTotal: boolean;
}) => {
  return <div data-sentry-component="SelectionEventList" data-sentry-source-file="EventList.tsx">
      {eventList.length > 0 ? <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
              <p className="mt-2 text-gray-600">{subtitle}</p>
            </div>
            {displayTotal && <div className="bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100">
              <div className="flex items-center gap-2 text-gray-600">
                <CalendarDays className="w-5 h-5" />
                <span className="font-medium">
                  {eventList.length} expérience(s)
                </span>
              </div>
            </div>}
          </div>
          <div className="grid grid-cols-1  gap-1 mb-6">
            {eventList.slice(0, displayCategories.includes(category) ? 20 : maxNumber).map((event, index: number) => <NewEventCard key={index} event={event} />)}
          </div>
          {eventList.length > maxNumber && !displayCategories.includes(category) ? <div className="flex items-center justify-center pb-6">
              <button onClick={() => {
          setDisplayCategories?.([...displayCategories, category]);
        }} className="px-4 py-2 text-white bg-blue-600 rounded-lg shadow-sm">
                Afficher les {eventList.length - maxNumber} autres expériences
              </button>
            </div> : <div></div>}
        </div> : <div></div>}
    </div>;
};
export default function EventList({
  availableEvents
}: ResultApiRecenTrips) {
  const topAvailableEvents = availableEvents.filter(event => event.eventTop === true);
  const [displayCategories, setDisplayCategories] = useState<string[]>([]);
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-sentry-component="EventList" data-sentry-source-file="EventList.tsx">
      <SelectionEventList eventList={topAvailableEvents} title="Meilleures expériences" category="TOP" subtitle="Choisissez parmi une variété d'expériences à venir" displayCategories={displayCategories} setDisplayCategories={setDisplayCategories} maxNumber={5} displayTotal={false} data-sentry-element="SelectionEventList" data-sentry-source-file="EventList.tsx" />

      {["MUSEUMS", "MONUMENTS", "TOURS", "FOOD_TOURING", "FOOD_TASTING", "COOKING_CLASS", "ATTRACTIONS", "TICKETS", "CRUISE", "SEGWAY/E-BIKE", "SHOWS"
    //"TEST",
    ].map((category, index: number) => {
      const categoryEvents = availableEvents.filter(event => event.event_category === category);
      return <SelectionEventList key={index} eventList={categoryEvents} category={category} title={EVENT_DESCRIPTION[category].title} subtitle={EVENT_DESCRIPTION[category].subtitle} displayCategories={displayCategories} setDisplayCategories={setDisplayCategories} maxNumber={3} displayTotal={true} />;
    })}
    </div>;
}